// hooks/useGateModel.js
import { useState, useEffect, useMemo } from "react";
import { useGLTF } from "@react-three/drei";

export function useGateModel({ onModelLoaded, setModelParams, isGateOpened }) {
  const {
    scene: originalScene,
    materials,
    animations,
  } = useGLTF("/models/vorotatest.glb");
  const [hasInitialized, setHasInitialized] = useState(false);
  const scene = useMemo(() => originalScene.clone(), [originalScene]);

  useEffect(() => {
    if (!materials || !setModelParams || hasInitialized) return;

    // Панели
    const panelNames = [
      "панель_1",
      "панель_2",
      "панель_3",
      "панель_4",
      "панель_5",
    ];
    const panels = panelNames
      .map((name) => scene.getObjectByName(name))
      .filter(Boolean);

    if (panels.length === 0) {
      console.error("Не найдено ни одной панели:", panelNames);
      return;
    }

    // Материалы панелей
    const panelMaterials = {};
    Object.entries(materials).forEach(([name, mat]) => {
      if (name.startsWith("панель_")) {
        panelMaterials[name] = mat;
      }
    });

    if (Object.keys(panelMaterials).length === 0) {
      console.warn("Нет материалов вида 'панель_'");
      return;
    }

    // Ворота и другие части
    const gates = {};
    ["широкая_полоса", "доска"].forEach((name) => {
      const obj = scene.getObjectByName(name);
      if (obj?.material) gates[name] = obj.material;
    });

    const wicket = scene.getObjectByName("калитка");
    const windows = scene.getObjectByName("окна");

    // Применить первый материал
    const firstMatName = Object.keys(panelMaterials)[0];
    const firstMat = panelMaterials[firstMatName].clone();
    panels.forEach((mesh) => (mesh.material = firstMat));

    setModelParams({
      palette: panelMaterials,
      panels,
      activeMaterial: firstMatName,
      gates,
      wicket,
      windows,
      activeGate: "широкая_полоса",
      isGateOpened: isGateOpened ?? false,
    });

    setHasInitialized(true);
    if (onModelLoaded) onModelLoaded();
  }, [
    materials,
    setModelParams,
    scene,
    hasInitialized,
    onModelLoaded,
    isGateOpened,
  ]);

  return { scene, materials, animations, initialized: hasInitialized };
}
